import $http from '@/model/utils/http'

// 获取账号列表
const getAccountList = (params) => $http.get('/org/member/index',{params})
// 添加账号
const addAccount = (params) => $http.post('/org/member/add', params)
// 修改账号密码及备注
const updateAccount = (params) => $http.put('/org/member/edit',params)
// 删除账号（禁用）
const deleteAccount = (params) => $http.put('/org/member/del', params)


export default {
    getAccountList,
    addAccount,
    updateAccount,
    deleteAccount
}
